import Vue from 'vue'
import VueRouter from 'vue-router'
import fetch from '../axios'
import { Toast, Dialog } from 'vant';
import routes from './routes'
import store from '../store'
import API from '../interface/api'

import { localStorage, sessionStorage } from '../assets/javascripts/webstorage'

Vue.use(VueRouter)
Vue.use(Toast)
Vue.use(Dialog)

const Router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes,
  mode: process.env.VUE_ROUTER_MODE,
  base: process.env.VUE_ROUTER_BASE
})

let token = localStorage.get('token')
let userinfo = localStorage.get('userinfo')
let title = sessionStorage.get('title')
let exam = sessionStorage.get('exam')
let quest = sessionStorage.get('quest')
let product = sessionStorage.get('product')

// 页面刷新时，重新赋值token 和 userinfo
if (token) {
  store.commit('login', token)
}

if (userinfo) {
  store.commit('userinfo', userinfo)
}

if (title) {
  store.commit('settitle', title)
}

if (exam) {
  store.commit('saveexam', exam)
}

if (quest) {
  store.commit('savequest', quest)
}

if (product) {
  store.commit('saveproduct', product)
}

// console.log(process.env)

Router.beforeEach((to, from, next) => {
  if (to.query.opentoken) {
    fetch.post(API.LOGINBYOPENTOKEN, {
      opentoken: to.query.opentoken
    })
      .then(response => {
        if (!response) {
          Toast.fail('获取用户信息失败');
        } else if (response.status === 200) {
          store.commit('login', response.data.tokenid)
          store.commit('userinfo', response.data)
          // console.log(to)
          if (to.query.auto === 'submit') {
            // console.log(store.state.examData)
            fetch.post(API.EXAMANSWER, {
              examid: store.state.examData.examid,
              examjson: store.state.examData.examjson,
              answertime: Math.round(store.state.examData.examtime/1000)
            }).then(response => {
              // console.log(response)
              if (response.status !== 200) {
                Toast.fail(response.message)
                setTimeout(function(){
                  next({
                    path: '/exam/list',
                    query: {
                      id: store.state.examData.examid
                    },
                    replace: true
                  })
                }, 2000)
                return
              }
              next({
                path: to.path,
                query: {
                  id: store.state.examData.examid
                },
                replace: true
              })
            }).catch(error => {
              let msg = error.message ? error.message : '提交失败，请稍后尝试!'
              Toast.fail(msg)
              setTimeout(function(){
                next({
                  path: '/exam/list',
                  query: {
                    id: store.state.examData.examid
                  },
                  replace: true
                })
              }, 2000)
              console.log(error)
            })
          } else if (to.query.auto === 'submitquest') {
            fetch.post(API.SAVEWJRESULT, {
              questionnaireid: store.state.questData.questionnaireid,
              questionnairejson: store.state.questData.questionnairejson
            }).then(response => {
              // console.log(response)
              if (response.status !== 200) {
                Toast.fail(response.message)
                setTimeout(function(){
                  if (to.query.mode === 'patrolman') {
                    next({
                      path: '/questionnaire/patrolman',
                      replace: true
                    })
                  } else {
                    next({
                      path: '/questionnaire/list',
                      query: {
                        id: store.state.questData.questionnaireid
                      },
                      replace: true
                    })
                  }
                }, 2000)
                return
              }
              var pathquery = to.query.type ? {type: to.query.type} : {id: store.state.questData.questionnaireid}
              setTimeout(() => {
                if (response.data.surplusnum > 0) {
                  Dialog.alert({
                    title: '投票成功',
                    message: `还剩余${response.data.surplusnum}次投票机会，欢迎继续投票`
                  }).then(() => {
                    // next({
                    //   path: to.path,
                    //   query: pathquery,
                    //   replace: true
                    // })
                  })
                } else {
                  Dialog.alert({
                    title: '投票成功',
                    message: '今日投票次数已用完,请明天再来!'
                  }).then(() => {
                    // next({
                    //   path: to.path,
                    //   query: pathquery,
                    //   replace: true
                    // })
                  })
                }
              }, 1000)
              next({
                path: to.path,
                query: pathquery,
                replace: true
              })
            }).catch(error => {
              let msg = error.message ? error.message : '提交失败，请稍后尝试!'
              Toast.fail(msg)
              setTimeout(function(){
                next({
                  path: '/questionnaire/list',
                  query: {
                    id: store.state.questData.questionnaireid
                  },
                  replace: true
                })
              }, 2000)
              console.log(error)
            })
          } else {
            next({
              path: to.path,
              query: {
                id: to.query.id
              },
              replace: true
            })
          }
        } else {
          Toast.fail('获取用户信息失败');
          // next({
          //   path: from.path,
          //   replace: true
          // })
        }
      })
      .catch(err => {
        let errorMsg = err.message || '请求失败，请检查访问地址是否正确'
        Toast.fail(errorMsg)
        // next({
        //   path: from.path,
        //   replace: true
        // })
      })
  } else if (to.matched.some(r => r.meta.notAuth)) {
    if (to.name === 'topicLogin') {
      next({
        path: '/topic2022/login',
        replace: true
      })
    } else {
      next()
    }
  } else if (to.matched.some(r => r.meta.topic)) {
    if (to.meta.topic === 'topic') {
      next({
        path: '/topic2022',
        replace: true
      })
    } else if (store.state.token) {
      if (JSON.stringify(userinfo) !== "{}"){
        next()
      } else {
        fetch.get(API.GETMEMBERBINFO).then(res => {
          store.commit('userinfo', res.data)
          next()
        })
      }
    } else {
        // Toast.fail('请在微信内打开')
      next({
        path: '/'+ to.meta.topic +'/login'
      })
    }
  } else {
    if (store.state.token) {
      if (JSON.stringify(userinfo) !== "{}"){
        next()
      } else {
        fetch.get(API.GETMEMBERBINFO).then(res => {
          store.commit('userinfo', res.data)
          next()
        })
      }
    } else {
      let u = navigator.userAgent
      if (u.indexOf('MicroMessenger') > -1) {
        next(false)
        console.log('微信授权登录中...')
        // console.log(window.location.origin + '/h5/#' + to.fullPath)
        var hrefF = process.env.VUE_APP_CURRENTMODE === 'test' ? '/h5/#' : '#'
        fetch.post(API.GETWECHATAUTHURI, {
          // url: window.location.origin + '/h5/#' + to.fullPath
          url: window.location.origin + hrefF + to.fullPath
        })
          .then(response => {
            // console.log(response)
            if (response.status === 200) {
              window.location.href = response.data.uri
            } else {
              // console.log(response.message)
            }
          })
      } else {
        console.log('请登录...')
        // Toast.fail('请在微信内打开')
        // console.log(to)
        if (to.path.indexOf('competition') > -1) {
          Toast.fail('请在微信内打开')
        } else {
          next({
            path: '/login',
            // replace: true,
            query: {
              redirect: to.path,
              id: to.query.id
            }
          })
        }
      }
    }
  }
})


Router.beforeResolve((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  } else if (document.title !== '粤科网') {
    document.title = '粤科网'
  }
  next()
})

export default Router